import {
  each,
  uniqueId,
} from "lodash";
import { AISummaries, AISummary } from "@radarly/models/ai";
import { isAICard } from "@radarly/models/cards/is";
import { DatavizTypeAI } from "@radarly/models/dataviz";
import { isCardRow } from "@radarly/models/insight-pages/row";
import { PublicPage } from "@radarly/models/public-pages";
import { AIFragment } from "@radarly/models/search";
import { AiRepo } from "./AiRepo";

// const reduceEmptyValues = (values) => {
//   return reduce(
//     values,
//     (acc, value, key: string) => {
//       if (
//         isString(value) ||
//         isBoolean(value) ||
//         isNumber(value) ||
//         isDate(value) ||
//         isMoment(value) ||
//         ((isObject(value) || isArray(value)) && size(value))
//       ) {
//         acc[key] = value;
//       }
//       return acc;
//     },
//     {}
//   );
// };

// const orderKeys = (unordered: object): object => {
//   const ordered = {};
//   Object.keys(reduceEmptyValues(unordered))
//     .sort()
//     .forEach((key) => {
//       const value = unordered[key];
//       if (
//         isString(value) ||
//         isBoolean(value) ||
//         isNumber(value) ||
//         isArray(value) ||
//         isDate(value) ||
//         isMoment(value)
//       ) {
//         ordered[key] = value;
//       } else if (isObject(value)) {
//         ordered[key] = orderKeys(value);
//       }
//     });
//   return ordered;
// };

export class PublicAiRepository implements AiRepo {
  private data: Record<string, AISummaries> = {};
  constructor(publicPage: PublicPage) {
    each(publicPage.customPage.rows, (row) => {
      if (isCardRow(row)) {
        each(row.cards, (card) => {
          if (card && isAICard(card)) {
            const fragment = card.fragments[0] as AIFragment;
            fragment.request.id = uniqueId("ai_query_");
            this.data[this.getKeyFromQuery(fragment.request)] =
              fragment.data as AISummaries;
          }
        });
      }
    });
  }

  private getKeyFromQuery(query: any) {
    return query.id;
  }

  public async getAISummary<T extends DatavizTypeAI>(
    pid: number,
    searchFragmentAI: AIFragment & { analysis: { type: T } }
  ): Promise<AISummary<T>> {
    return this.data[
      this.getKeyFromQuery(searchFragmentAI.request)
    ] as AISummary<T>;
  }
}
